module.exports = __webpack_public_path__ + "static/media/onedrive.3136194d.svg";